import { Button, ButtonProps, Tooltip } from 'antd'
import React, { FC, ReactNode } from 'react'

export type TActionBlkBtn = ButtonProps & {
 text: string
 icon: ReactNode
 color:
  | 'primary'
  | 'success'
  | 'secondary'
  | 'info'
  | 'warning'
  | 'danger'
  | 'alpha'
  | 'beta'
  | 'gamma'
  | 'gray'
 variant?: 'solid' | 'outline'
 group?: string
 tooltipText?: string
 btnClassName?: string
 ref?: any
 key?: any
}

const ActionBlkBtn: FC<TActionBlkBtn> = ({
 color,
 icon,
 text,
 variant = 'outline',
 tooltipText,
 btnClassName = '',
 ref,
 key,
 ...btnProps
}) => {
 const isSolid = variant === 'solid'
 // Extract disabled so we don't pass it to Ant Design's Button —
 // AntD wraps disabled buttons in a <span cursor:not-allowed> which breaks flex layout.
 const { disabled, onClick, ...restBtnProps } = btnProps
 const isDisabled = !!disabled

 return (
  <Tooltip title={tooltipText ?? text}>
   <Button
    key={key}
    ref={ref}
    {...restBtnProps}
    onClick={isDisabled ? undefined : onClick}
    className={`action-blk-btn ${
     isSolid ? `solid-btn solid-btn-${color}` : `outline-btn icon-${color}`
    } ${btnClassName ?? ''} ${isDisabled ? 'blk-btn-disabled' : ''}`}
   >
    {icon && <span className="action-blk-icon">{icon}</span>}
    <span className="btn-text">{text}</span>
   </Button>
  </Tooltip>
 )
}

export default ActionBlkBtn
